import React, { useState, Children, cloneElement, isValidElement, useEffect } from 'react';
import styles from './HierarchicalAccordion.module.css';

// Definiamo un tipo per le props attese dai children diretti
interface AccordionItemProps {
  id: string | number;
  // Aggiungi altre props che HierarchicalAccordionItem potrebbe avere e che HierarchicalAccordion necessita di conoscere
  // per ora, id è sufficiente per la logica di clonazione.
  // isOpen e onToggle verranno iniettate, quindi non è necessario definirle qui.
}

interface HierarchicalAccordionProps {
  children: React.ReactNode; // Può essere un singolo child o un array di children
  defaultOpenId?: string | number | null;
  style?: React.CSSProperties; // Aggiunta prop style
}

const HierarchicalAccordion: React.FC<HierarchicalAccordionProps> = ({ children, defaultOpenId = null, style }) => {
  const [openItemId, setOpenItemId] = useState<string | number | null>(defaultOpenId);

  useEffect(() => {
    if (defaultOpenId !== null && defaultOpenId !== openItemId) {
      setOpenItemId(defaultOpenId);
    }
    // Non chiudiamo l'accordion se defaultOpenId diventa null dopo essere stato impostato,
    // per permettere all'utente di chiuderlo manualmente.
  }, [defaultOpenId]); // Rimosso openItemId dalle dipendenze per evitare loop

  const handleToggle = (id: string | number) => {
    setOpenItemId(prevOpenId => (prevOpenId === id ? null : id));
  };

  return (
    <div className={styles.hierarchicalAccordion} style={style}> {/* Applica style qui */}
      {Children.map(children, (child) => {
        // Controlla se il child è un elemento React valido e ha una prop 'id'
        if (isValidElement<AccordionItemProps>(child) && typeof child.props.id !== 'undefined') {
          // Clona l'elemento figlio, iniettando le props isOpen e onToggle
          return cloneElement(child as React.ReactElement<AccordionItemProps & { isOpen?: boolean; onToggle?: () => void }>, {
            isOpen: child.props.id === openItemId,
            onToggle: () => handleToggle(child.props.id),
          });
        }
        return child; // Ritorna il child non modificato se non corrisponde ai criteri
      })}
    </div>
  );
};

export default HierarchicalAccordion;